import { useEffect, useState } from "react";
import { Typography, Box } from "@material-ui/core";
import moment from "moment";

import { QuizStatuses } from "../../store/Learn2/learn.interface";
import { useLearnContext } from "../../store/Learn2/LearnContext";

const LearnQuizTimer = () => {
  const { quizzes, quizIndex, quizStartTime, quizStatus } = useLearnContext();

  // const { quizStartTime = 1711117449425, quizStatus } = liveQuiz ?? {};
  const quiz = quizzes?.[quizIndex];

  const [timerExpired, setTimerExpired] = useState<boolean>(false);
  const [formattedQuizDuration, setFormattedQuizDuration] =
    useState<string>("");

  const timeLimitInSeconds = quiz?.timeLimitInSeconds ?? 0;
  const quizDuration = moment.duration(timeLimitInSeconds, "seconds");
  const defaultTimeLimitFormat = `${quizDuration
    .hours()
    .toString()
    .padStart(2, "0")}:${quizDuration
    .minutes()
    .toString()
    .padStart(2, "0")}:${quizDuration.seconds().toString().padStart(2, "0")}`;

  useEffect(() => {
    const intervalId: any = setInterval(() => {
      timerCounter();
    }, 1000);
    return () => {
      if (quizStatus !== "ON_GOING") {
        clearInterval(intervalId);
      }
    };
  }, [quizStatus]);

  const timerCounter = () => {
    if (quizStartTime) {
      const currentTime = moment();
      const startTime = moment(quizStartTime);

      const duration = moment.duration(currentTime.diff(startTime));
      const durationInSeconds = moment
        .duration(currentTime.diff(startTime))
        .asSeconds();

      if (durationInSeconds >= timeLimitInSeconds) {
        setTimerExpired(true);
      }
      setFormattedQuizDuration(
        `${duration.hours().toString().padStart(2, "0")}:${duration
          .minutes()
          .toString()
          .padStart(2, "0")}:${duration.seconds().toString().padStart(2, "0")}`
      );
    }
  };

  if (
    !quizStartTime ||
    quizStatus !== QuizStatuses.ON_GOING ||
    !formattedQuizDuration
  ) {
    return (
      <Box display="flex" flexDirection="column">
        {/**flex box item */}
        <Typography variant="body1" color={"primary"} className="fw-bold">
          {defaultTimeLimitFormat}
        </Typography>
        <Typography variant="subtitle1" className="fw-normal text-darkslate">
          Quiz time limit
        </Typography>
      </Box>
    );
  }

  return (
    <Box display="flex" flexDirection="column">
      <Box
        style={{
          display: "flex",
          alignItems: "center",
          gap: ".25rem",
        }}
      >
        <Typography
          variant="body1"
          color={timerExpired ? "error" : "primary"}
          className="fw-bold"
        >
          {formattedQuizDuration}
        </Typography>
        <Typography variant="body1" color="primary" className="fw-bold">
          /
        </Typography>
        <Typography variant="body1" color={"primary"} className="fw-bold">
          {defaultTimeLimitFormat}
        </Typography>
      </Box>
      <Typography variant="subtitle1" className="fw-normal text-darkslate">
        Quiz time limit
      </Typography>
    </Box>
  );
};

export const isQuizExpired = (options: {quizStartTime?: number, timeLimitInSeconds?: number}) => {

  const {quizStartTime, timeLimitInSeconds }= options
  if(timeLimitInSeconds && quizStartTime){
    const currentTime = moment();
    const startTime = moment(quizStartTime);
  
    const durationInSeconds = moment
      .duration(currentTime.diff(startTime))
      .asSeconds();
  
    if (durationInSeconds >= timeLimitInSeconds) {
      return true
    }

    return false
  }

  return true
  
}

export default LearnQuizTimer;
